export interface ICalendarScheduleModelData {
  result: CalendarSchedule[];
}

export class CalendarSchedule implements ICalendarSchedule {
  id!: number;
  subject!: string;
  startTime!: Date;
  endTime!: Date;
  recurrenceRule!: string;
  customerID!: number;
  siteID!: number;
  nvrID!: number;
  cameraID!: number;
  cameraIDs!: number[];
  categoryColor!: string;
  isReadonly!: boolean;
  exceptionDate!: Date;
  childEntities!: string[];
  nvrEntities!: string[];
  cameraEntities!: string[];
  childType!: string;
  intervalID!: number;
  olson!: string;
  zone!: string;
  isDSTIgnored!: boolean;
  isAssigned!: boolean;
  localTimeString!: string;
  dallasTimeString!: string;
  torontoTimeString!: string;
  manilaTimeString!: string;

  isHoliday?: boolean;
  notes?: string;

  createdByName: string;

  constructor(data?: ICalendarSchedule) {
    if (data) {
        for (let property in data) {
            if (data.hasOwnProperty(property)) {
                (<any>this)[property] = (<any>data)[property];
            }
        }
    }
  }

  init(data?: any) {
    if (data) {
        this.id = data['id'];
        this.subject = data['subject'];
        this.startTime = new Date(data['startTime']);
        this.endTime = new Date(data['endTime']);
        this.recurrenceRule = data['recurrenceRule'];
        this.customerID = data['customerID'];
        this.siteID = data['siteID'];
        this.nvrID = data['nvrid'];
        this.cameraID = data['cameraID'];
        this.cameraIDs = [];
        this.isReadonly = false;
        this.categoryColor = data['primaryColor'];
        this.childEntities = [];
        this.childType = '';
        this.intervalID = 0;
        this.olson = data['olson'];
        this.zone = data['zone'];
        this.isDSTIgnored = data['isDSTIgnored'];
        this.isAssigned = data['isAssigned'];
        this.localTimeString = '';
        this.dallasTimeString = '';
        this.torontoTimeString = '';
        this.manilaTimeString = '';

        this.isHoliday = data['isHoliday'];
        this.notes = data['notes'];
        this.createdByName = data['createdByName'];
    }
  }

  // tslint:disable-next-line:member-ordering
  static fromJS(data: any): CalendarSchedule {
      data = typeof data === 'object' ? data : {};
      let result = new CalendarSchedule();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id;
      data['subject'] = this.subject;
      data['startTime'] = this.startTime;
      data['endTime'] = this.endTime;
      data['recurrenceRule'] = this.recurrenceRule;
      data['customerID'] = this.customerID;
      data['siteID'] = this.siteID;
      data['nvrid'] = this.nvrID;
      data['cameraID'] = this.cameraID;
      data['primaryColor'] = this.categoryColor;

      data['isHoliday'] = this.isHoliday;
      data['notes'] = this.notes;

      data['createdByName'] = this.createdByName;

      return data;
  }
}

export interface ICalendarSchedule {
  id: number;
  subject: string;
  startTime: Date;
  endTime: Date;
  recurrenceRule: string;
  customerID: number;
  siteID: number;
  nvrID: number;
  cameraID: number;
  cameraIDs: number[];
  categoryColor: string;
  isReadonly: boolean;
  exceptionDate: Date;
  childEntities: string[];
  childType: string;
  intervalID: number;
  olson: string;
  zone: string;
  isDSTIgnored: boolean ;
  isAssigned: boolean;
  localTimeString: string;
  dallasTimeString: string;
  torontoTimeString: string;
  manilaTimeString: string;

  isHoliday?: boolean;
  notes?: string;

  createdByName?: string;
}

export class FullCalendarTooltip implements IFullCalendarTooltip {
  localTimeString!: string;
  dallasTimeString!: string;
  torontoTimeString!: string;
  manilaTimeString!: string;
}

export interface IFullCalendarTooltip {
  localTimeString: string;
  dallasTimeString: string;
  torontoTimeString: string;
  manilaTimeString: string;
}

export class ScheduleExceptionDto implements IScheduleExceptionDto {
  exceptionId!: number;
  deviceId!: number;
  startTime!: Date;
  endTime!: Date;
  isMonitored!: boolean;
  createdBy!: number;
  createdDate!: Date;
  updatedBy!: number;
  updatedDate!: Date;
}

export interface IScheduleExceptionDto {
  exceptionId: number;
  deviceId: number;
  startTime: Date;
  endTime: Date;
  isMonitored: boolean;
  createdBy: number;
  createdDate: Date;
  updatedBy: number;
  updatedDate: Date;
}

export class DeviceTemplateDto implements IDeviceTemplateDto {
  deviceId!: number;
  deviceTypeId!: number;
  parentId!: number;
  createdBy!: number;
  createdDate!: Date;
  updatedBy!: number;
  updatedDate!: Date;
}

export interface IDeviceTemplateDto {
  deviceId: number;
  deviceTypeId: number;
  parentId: number;
  createdBy: number;
  createdDate: Date;
  updatedBy: number;
  updatedDate: Date;
}

export class DeleteGroupScheduleExceptionDto {
  overrideId: number;
  deviceIds: Array<number> | null;
}

export class UpdateGroupScheduleExceptionDto {
  overrideId: number;
  overrideDate: Date;
  startTime: Date;
  endTime: Date;
  isMonitored: boolean;
  overrideReasonTypeID: number;
  requestor: string;
  updatedBy: number | null;
  updatedDate: number | null;
}
